import content from '../content.json';

/* Unsplash pictures filter = ?auto=format&fit=crop&h=300&w=500&q=60 */

const Cards = content.cards;

export const getIndexById = (id) => Cards.findIndex((card) => card.id === id);

export const getCardById = (id) => Cards.find((card) => card.id === id);

export const getDisplayNumberById = (id) => (getIndexById(id) + 1).toString().padStart(3, '0');

export const getQuestionsById = (id) => {
	const questions = {};

	// eslint-disable-next-line no-restricted-syntax
	for (const [key, value] of Object.entries(getCardById(id).info)) {
		if ('question' in value) questions[key] = value;
	}

	return questions;
};

export const getModelUrlById = (id) =>
	`${window.location.origin}/klokhuisscanner/models/${id}_small.glb?update=1`;

export const getAnimationUrl = () =>
	`${window.location.origin}/klokhuisscanner/models/animation.glb`;

export const getPlaceDisplayName = (place) => {
	switch (place) {
		case 'potted plant':
			return 'plantenpot';
		case 'bed':
			return 'bed';
		case 'couch':
			return 'bank';
		case 'sink':
			return 'gootsteen';
		case 'toilet':
			return 'toilet';
		case 'banana':
			return 'banaan';
		case 'apple':
			return 'appel';
		case 'sandwich':
			return 'broodje';
		case 'orange':
			return 'sinaasappel';
		case 'dog':
			return 'hond';
		case 'cat':
			return 'kat';
		case 'person':
			return 'mens';
		case 'bird':
			return 'vogel';
		case 'horse':
			return 'paard';
		case 'cell phone':
			return 'telefoon';
		case 'teddy bear':
			return 'knuffel';
		case 'keyboard':
			return 'toetsenbord';
		case 'mouse':
			return 'muis';
		case 'backpack':
			return 'rugzak';
		case 'remote':
			return 'afstandsbediening'
		default:
			return place;
	}
};

export const getRandomCard = () => Cards[Math.floor(Math.random() * Cards.length)];

export const getRandomPlace = () => {
	const randomCard = getRandomCard();
	return randomCard.places[Math.floor(Math.random() * randomCard.places.length)];
};

export default Cards;
